module.exports = __webpack_public_path__ + "bd0534cc38f194b42b5c774245d59f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forgetPWHumi.png
// module id = 760
// module chunks = 2